export default function randomId() {
    return Math.random().toString(36).split('.').pop();
}
